import { DomainDto } from '../../../dtos/domain'
import { DomainConditionOptions, EntityConditionOptions, OrgConditionOptions } from '../types'
import { PlatformLevel } from '../enums/platform-level'

export const ensureDomain = (opts): opts is DomainConditionOptions => opts.platformLevel === PlatformLevel.DOMAIN
export const ensureOrg = (opts): opts is OrgConditionOptions => opts.platformLevel === PlatformLevel.ORG

export const ensureBreakdown =
    (bd: string) =>
    ({ breakdown }: EntityConditionOptions): boolean =>
        breakdown === bd

/**
 * A domain is e-commerce enabled when it carries an e-commerce configuration.
 * This is deliberately not a feature flag lookup - `domain.flags` never contains
 * an e-commerce entry, so `ensureDomainFlag` cannot answer this question.
 *
 * Every surface that shows purchase data shares this one predicate, so those surfaces
 * cannot drift apart on which domains qualify. The Catalog navigation item asks a
 * narrower question - `shouldShowCatalogNavItem` additionally requires a configured item
 * type, without which there is no catalog to browse - so a domain configured for
 * e-commerce but not for an item type reports purchases and offers no Catalog.
 */
export const domainHasEcommerceEnabled = (domain: DomainDto | null | undefined): boolean =>
    domain?.ecommConfig !== undefined && domain?.ecommConfig !== null

/**
 * Column/filter condition form of {@link domainHasEcommerceEnabled}: the report must be
 * domain-scoped (org-scoped reports span domains with mixed e-commerce state) and that
 * domain must have e-commerce enabled.
 */
export const ensureEcommerceDomain = (opts: EntityConditionOptions): opts is DomainConditionOptions =>
    ensureDomain(opts) && domainHasEcommerceEnabled(opts.domain)
